const STEP_SUBTITLE_COMPONENTS = {
  sep: <span className="hidden lg:inline" />,
  step: <span className="block lg:inline" />,
};

export {STEP_SUBTITLE_COMPONENTS};
